import type {DashboardSidebar} from '@github-ui/shared-dashboard-sidebar/DashboardSidebar'
import type {ComponentProps} from 'react'

import {REPO_PULLS_DEFAULT_QUERY} from './repo-pulls-dashboard-content-route'

type RepoPullsSidebarLink = ComponentProps<typeof DashboardSidebar>['links'][number]

export const REPO_PULLS_SIDEBAR_LINKS: RepoPullsSidebarLink[] = [
  {
    id: 'all',
    name: 'Pull requests',
    searchType: 'pull-requests',
    query: REPO_PULLS_DEFAULT_QUERY,
    icon: 'inbox',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'authored',
    name: 'Authored by me',
    searchType: 'pull-requests',
    query: `${REPO_PULLS_DEFAULT_QUERY} author:@me`,
    icon: 'smiley',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'assigned',
    name: 'Assigned to me',
    searchType: 'pull-requests',
    query: `${REPO_PULLS_DEFAULT_QUERY} assignee:@me`,
    icon: 'person',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'involved',
    name: 'Involves me',
    searchType: 'pull-requests',
    query: `${REPO_PULLS_DEFAULT_QUERY} involves:@me`,
    icon: 'comment',
    color: 'gray',
    source: 'predefined',
  },
  {
    id: 'review-requested',
    name: 'Review requests',
    searchType: 'pull-requests',
    query: `${REPO_PULLS_DEFAULT_QUERY} review-requested:@me`,
    icon: 'git_pull_request',
    color: 'gray',
    source: 'predefined',
  },
]

export function normalizeRepoPullsQuery(query: string) {
  return query.trim().split(/\s+/).filter(Boolean).join(' ')
}

export function getSelectedRepoPullsSidebarLink(query: string) {
  const normalizedQuery = normalizeRepoPullsQuery(query)
  return REPO_PULLS_SIDEBAR_LINKS.find(link => normalizeRepoPullsQuery(link.query) === normalizedQuery)
}
